import styled from 'styled-components';

export const OrganizationBox = styled.div`
    background-color: ${p => p.theme.muiTheme.palette.secondary.main};
    margin: 10px auto;
    padding: 20px;

    h4,
    h5 {
        margin-bottom: 10px;
        text-transform: uppercase;
    }
`;
